import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();

  // 🔓 DEV MODE: Set to true to disable authentication in development
  const DISABLE_AUTH_DEV = true; // Change to false to re-enable auth

  if (DISABLE_AUTH_DEV && process.env.NODE_ENV === 'development') {
    console.log('🔓 Auth disabled for development');
    return children;
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
